@if (isLoading()) {
  <div class="global-loader-overlay">
    <p-progressspinner 
      [style]="{ width: '50px', height: '50px' }"
      strokeWidth="4"
      animationDuration="1s">
    </p-progressspinner>
  </div>
}
